import Config from '../Config';
import { RestService } from './RestService';

export const RouteService = {
    getRouteList: async function(){
        return RestService.get(`${Config.get_routes}`, {})
        .then(response => response.json());
    },
    getRouteListWithMapping: async function(){
        return RestService.get(`${Config.get_routes_with_mapping}`, {})
        .then(response => response.json());
    },
    getStoreRouteMappings: async function(){
        return RestService.get(`${Config.get_store_routes}`, {})
        .then(response => response.json());
    },
    assignRouteToStore: async function(body, headers = {}) {
        return RestService.post(`${Config.assign_store_route}`, headers , body)
        .then(response => response.json());
    },
    removeStoreRouteAssignment: async function(route_id, store_id, headers = {}) {
        return RestService.get(`${Config.remove_store_assignment}route_id=${route_id}&store_id=${store_id}`, headers )
        .then(response => response.json());
    },
    getDetailedRoute: async function(){
        return RestService.get(`${Config.get_detailed_routes}`, {})
        .then(response => response.json());
    },
    removeRoute: async function(id, headers = {}){
        return RestService.get(`${Config.remove_route}id=${id}`, headers)
        .then(response => response.json());
    },
    removeAgentAssigned: async function(id, agent_id, headers = {}){
        return RestService.get(`${Config.remove_agent_assignment}route_id=${id}&user_id=${agent_id}`, headers)
        .then(response => response.json());
    },
    assignRouteToAgent: async function(body, headers = {}){
        return RestService.post(`${Config.assign_route}`, headers, body)
        .then(response => response.json());
    },
    createRoute: async function(body, headers = {}){
        return RestService.post(`${Config.create_route}`, headers, body)
        .then(response => response.json());
    },
    schedulingChanges: async function(body, headers = {}){
        return RestService.post(`${Config.route_scheduling_changes}`, headers, body)
        .then(response => response.json());
    },
    getRouteAreaCoordinates: async function(){
        return RestService.get(`${Config.get_route_area}`, {})
        .then(response => response.json());
    },
    getStoreDeliveriesForAgent: async function(agent_id = null, date = null){
        return RestService.get(`${Config.get_store_deliveries_for_agent}${agent_id ? `agent_id=${agent_id}` : ''}${date ? `&date=${date}` : ''}`, {})
        .then(response => response.json());
    },
    saveOrder: async function(header = {}, body){
        return RestService.post(`${Config.save_store_route_order}`, header, body)
        .then(response => response.json());
    },
    saveOrderV2: async function(header = {}, body){
        return RestService.post(`${Config.save_store_route_order_v2}`, header, body)
        .then(response => response.json());
    },
};